import PropTypes from "prop-types"
import React from "react"

const LineChartIcon = ({ direction, colorClass }) => {
  const isUp = direction === "up"
  const fillColorClass = colorClass || (isUp ? "fill-teal-500" : "fill-red-500")
  const rotateClass = isUp ? "" : "rotate-180 -scale-x-100"

  return (
    <svg
      className={`${rotateClass} h-8 w-8`}
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_179_12508"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="33"
        height="32"
      >
        <rect x="0.5" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_179_12508)">
        <path
          className={fillColorClass}
          d="M5.03366 24L3.16699 22.1333L10.2337 15.0667C11.0114 14.2889 11.9559 13.9 13.067 13.9C14.1781 13.9 15.1225 14.2889 15.9003 15.0667L17.4337 16.6C17.7003 16.8667 18.017 17 18.3837 17C18.7503 17 19.067 16.8667 19.3337 16.6L25.267 10.6667H21.8337V8H29.8337V16H27.167V12.5667L21.2003 18.5C20.4225 19.2778 19.4781 19.6667 18.367 19.6667C17.2559 19.6667 16.3114 19.2778 15.5337 18.5L13.967 16.9333C13.7225 16.6889 13.4114 16.5667 13.0337 16.5667C12.6559 16.5667 12.3448 16.6889 12.1003 16.9333L5.03366 24Z"
        />
      </g>
    </svg>
  )
}

LineChartIcon.propTypes = {
  direction: PropTypes.oneOf(["up", "down"]).isRequired,
  colorClass: PropTypes.string,
}

export default LineChartIcon
